import module from 'module';
import _ from 'lodash';
import moment from "moment";

import templateUrl from './pawn-waive.template.html';

class PawnWaiveView {
  constructor($route, $location, http, customerCache, confirmation, popup, newPawnService, command,
              confirmationTemplate, $filter) {
    this.$route = $route;
    this.$location = $location;
    this.http = http;
    this.customerCache = customerCache;
    this.confirmation = confirmation;
    this.newPawnService = newPawnService;
    this.command = command;
    this.popup = popup;
    this.confirmationTemplate = confirmationTemplate;
    this.$filter = $filter;
  }

  async $onInit() {
    this.customerId = this.$route.current.params['customerId'];
    const pawns = await this.customerCache.pawns(this.customerId).toPromise();
    this.pawnId = this.$route.current.params['pawnId'];
    this.pawn = _.find(pawns, p => p.id == this.pawnId);

    this.parts = [{
      name: 'Penalty',
      waiveType: 'PENALTY',
      fromDateLabel: 'Penalty From Date',
      toDateLabel: 'Penalty To Date',
      balance: this.pawn.penaltyBalance,
      isWaived: false,
      dateFrom: null,
      dateTo: null,
      amount: null
    }, {
      name: 'Past due interest',
      waiveType: 'PAST_DUE_INTEREST',
      fromDateLabel: 'Past Due Interest From',
      toDateLabel: 'Past Due Interest To',
      balance: this.pawn.pastDueInterestBalance,
      isWaived: false,
      dateFrom: null,
      dateTo: null,
      amount: null
    }];
  }

  formatDate(date) {
    return date ? moment(date).format('YYYY-MM-DD') : null;
  }

  async calculate(part) {
    try {
      const calculation = await this.http.post(`/products/pawns/${this.pawn.id}/calculate-waive-part/${part.waiveType}`).toPromise();
      part.amount = calculation.amount;
      part.dateFrom = calculation.dateFrom;
      part.dateTo = calculation.dateTo;
    } catch (error) {
      this.popup({
        header: 'Error',
        text: error.errorMessage
      });
    }
  };

  redirectBack() {
    this.$location.path(`/customer/${this.customerId}/pawns/${this.pawnId}`);
  }

  getValidParts() {
    return (this.parts || []).filter(part => part.amount > 0 && part.isWaived);
  }

  isWaiveEnabled() {
    return this.getValidParts().length > 0;
  }

  async waive() {
    const proceed = await this.confirmationTemplate({
      question: `Do you want to waive following parts?`,
      details: this.getValidParts().map(part => (
        {label: part.name, description: this.$filter('php')(part.amount)}))
    });

    if (!proceed) {
      return;
    }

    const commandInput = {
      productId: this.pawn.id,
      parts: this.getValidParts().map(part => ({...part, dateTo: this.formatDate(part.dateTo)}))
    };
    const response = await this.command.execute('WaivePawn', commandInput).toPromise();
    if (response.approvalRequired) {
      return;
    }

    this.customerCache.pawns(this.customerId).refetch();
    this.newPawnService.removeAll();
    this.$location.path(`/customer/${this.customerId}/pawns/${this.pawn.id}`);
  };
}

module.component('customerPawnWaive', {
  templateUrl: templateUrl,
  controller: PawnWaiveView
});
